import { createSelector } from 'reselect';
import {List, Map} from 'immutable';

function exist(obj, cb, def){
    let result;
    if(obj)
        result = cb(obj)
    if(result)
        return result
    return def;
}

const getItemsSelector = (state) => state.getIn(['conversation', 'items'], Map());
const getItems = getItemsSelector;
const getConversations = getItemsSelector;

// get conversation type
const typeOf = (conversation) => conversation.getIn(['meta', 'type']);
const getType = typeOf;
const getUnread = (conversation, userId) => conversation.getIn(['meta', 'read', userId.toString()], 0)

const getUnreadFromState = (state, room, userId) => state.getIn(['conversation', 'items', room, 'meta', 'read', userId.toString()], 0);
const getByRoom = (state, room) =>  state.getIn(['conversation', 'items', room], Map());

const _getConfirmedEntries = (conversation) => conversation.getIn(['entries', 'confirmed'], List())
const getConfirmedEntries = (conversation) => exist(conversation, _getConfirmedEntries, List());

const _getUnconfirmedEntries = (conversation) => conversation.getIn(['entries', 'unconfirmed'], List())
const getUnconfirmedEntries = (conversation) => exist(conversation, _getUnconfirmedEntries, List());

const hasBeenFetched = (conversation) => conversation.getIn(['entries', 'fetched']) ? true : false;


//IS TYPING
const getIsTyping = (state, room) => state.getIn(['conversation', 'items', room, 'meta', 'typing'], Map());

const getDateCreated = (conversation) => conversation.getIn(['info', 'payload', 'date_created']);

const getDateModified = (conversation) => conversation.getIn(['info', 'payload', 'date_modified']);

const isResolved = (conversation) => conversation.getIn(['meta', 'type'])

const getAssignedEmployee = (conversation) => conversation.getIn(['info', 'payload', 'assigned_employee_id'])

// GET CONVERSATION DEPENDS ON TYPE
const _typeFilter = (conversation, type) => typeOf(conversation) === type;

// const _ownConversation = (conversation, assignedEmployee) => assignedEmployee ===

const assignedTickets = createSelector(
  getItemsSelector,
  items => items.filter((item) => _typeFilter(item, 'assigned'))
)

const unassignedTickets = createSelector(
  getItemsSelector,
  items => items.filter((item) => _typeFilter(item, 'unassigned'))
)

const internCoworkerConversations = createSelector(
  getItemsSelector,
  items => items.filter((item) => _typeFilter(item, 'intern'))
                .filter((item) => item.getIn(['info', 'payload', 'private']) === true)
)

const getNumberOfUnreadConversations = (conversations, userId) => {
    let numberOfUnread = 0
    if(!conversations) return 0
    conversations.forEach(convo => {
        if(getUnread(convo, userId)) numberOfUnread += 1
    })
    return numberOfUnread
}

const getFirstConversation = (state) => {
    let getConvo = (conversations) => {
        let latestId = 0
        let latestConvo = 0
        conversations.forEach(convo => {
            let id = convo.getIn(['entries', 'confirmed', -1, 'id'], 0);
            if (id > latestId){
                latestId = id
                latestConvo = convo
            }
        })
        return latestConvo
    }

     let convo = getConvo(assignedTickets(state))
     if(convo.size){ return convo }
     convo = getConvo(unassignedTickets(state))
     if(convo.size){ return convo }
     convo = getConvo(internCoworkerConversations(state))
     if(convo.size){ return convo }
     return Map()
}
// OTHer
const getConversationId = (conversation) => conversation.getIn(['info', 'payload', 'company_ticket_id']);

const getTags = (conversation) => conversation.getIn(['info', 'payload', 'tag'])

const getNote = () =>  null;

const _getCustomerId = (conversation) => conversation.getIn(['info', 'payload', 'customer_id'], '');
const getCustomerId = (conversation, defaultValue) => exist(conversation, _getCustomerId, defaultValue);

const _getCustomerName = (conversation) => conversation.getIn(['info', 'payload', 'customer', 'name'], '');
const getCustomerName = (conversation, defaultValue) => exist(conversation, _getCustomerName, defaultValue);

// =========================================== //
// ================= NO REDUX ================ //
// =========================================== //
const _getCompanyCustomerId = (conversation) => conversation.getIn(['info', 'payload', 'company_customer_id'], '');
const getCompanyCustomerId = (conversation, defaultValue) => exist(conversation, _getCompanyCustomerId, defaultValue);
const getParticipantsId = (conversation) => conversation.getIn(['info', 'payload', 'participants'])
const getRead = (conversation) => conversation.getIn(['meta', 'read'])
const _getExchange = (conversation) => conversation.getIn(['info', 'payload', 'exchange'])
const getExchange = (conversation) => exist(conversation, _getExchange, Map()).toJS();

function lastEntry(conversation) {
    let entries = conversation.getIn(['entries', 'confirmed'])
    if(!entries || !entries.size) return null;
    return entries.last().toJS()
}

// get title depends on the conversation and the logged in user
export default {
    getItems, getConversations,
    getFirstConversation,getNumberOfUnreadConversations,
    assignedTickets,
    unassignedTickets,
    internCoworkerConversations,
    lastEntry,
    typeOf, getType,
    getByRoom,
    getUnread, getUnreadFromState,
    getConfirmedEntries,
    getUnconfirmedEntries,
    getCustomerId, getCompanyCustomerId,
    getNote,
    getParticipantsId,
    getIsTyping,
    getTags, getRead,
    getDateCreated,
    getConversationId,
    getDateModified,
    getExchange,
    isResolved,
    getAssignedEmployee,
    hasBeenFetched,
    getCustomerName
};



// WEBPACK FOOTER //
// ./src/model/Conversation/selector.js